import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';

const permissions = config.get('Permissions') || {};

export const Text = _.constant([
  'Text', 'Title', 'DisplayUrl', 'DestinationUrl', 'DevicePreference', 'FinalUrls', 'MobileFinalUrls', 'TrackingUrlTemplate', 'UrlCustomParameters', 'FinalUrlSuffix', 'NativePreference',
]);

export const AppInstall = _.constant([
  'AppPlatform', 'AppStoreId', 'Title', 'Text', 'FinalUrls', 'DevicePreference', 'TrackingUrlTemplate', 'UrlCustomParameters', 'FinalUrlSuffix', 'DestinationUrl', 'AltText', 'MediaUrl', 'DeviceType',
]);

export const DynamicSearch = _.constant([
  'Text', 'TextPart2', 'Path1', 'Path2', 'DevicePreference', 'TrackingUrlTemplate', 'UrlCustomParameters', 'FinalUrlSuffix',
]);

export const Product = _.constant([
  'PromotionalText',
]);

const expandedTextFields = ['TitlePart1', 'TitlePart2', 'Text', 'Path1', 'Path2', 'FinalUrls', 'TrackingUrlTemplate', 'UrlCustomParameters', 'FinalUrlSuffix', 'MobileFinalUrls', 'NativePreference'];

if (permissions.IsVanityUrlEnabled) {
  expandedTextFields.push('DisplayUrl');
}

if (permissions.IsExpandedTextAdV2Enabled) {
  expandedTextFields.push('TitlePart3', 'TextPart2');
}

export const ExpandedText = _.constant(expandedTextFields);

const responsiveSearchFields = [
  'Path1',
  'Path2',
  'Headlines',
  'Descriptions',
  'FinalUrls',
  'TrackingUrlTemplate',
  'UrlCustomParameters',
  'FinalUrlSuffix',
  'MobileFinalUrls',
  'NativePreference',
];

if (permissions.IsVanityUrlEnabled) {
  responsiveSearchFields.push('DisplayUrl');
}

export const ResponsiveSearch = _.constant(responsiveSearchFields);

const responsiveFields = [
  'Headline',
  'Headlines',
  'LongHeadline',
  'LongHeadlines',
  'Text',
  'Descriptions',
  'BusinessName',
  'Images',
  'FinalUrls',
  'FinalUrlSuffix',
  'TrackingUrlTemplate',
  'UrlCustomParameters',
  'MobileFinalUrls',
  'CallToAction',
  'CallToActionLanguage',
];

export const Responsive = _.constant(responsiveFields);
